// Tenant context for every cart/order request: account, channel, location,
// and the active currency. Seeded from the industry config (with .env overrides
// for local dev) and persisted so reload doesn't lose location selection.
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { STORE_CONTEXT_STORAGE_KEY } from '@core/constants/auth';

/** @typedef {import('@core/types').CurrencyConfig} CurrencyConfig */

const empty = {
  accountId: '',
  channelId: '',
  locationId: '',
  brandId: '',
  brandName: '',
  companyId: '',
  companyName: '',
  accountCountry: '',
  customerLocation: null,
  isRuntimeSwitching: false,
  priceField: 'online_price',
  currencyConfig: /** @type {CurrencyConfig | null} */ (null),
};

export const useStoreContextStore = create(
  persist(
    (set) => ({
      ...empty,

      hydrate: (next) => set((s) => ({ ...s, ...next })),
      setLocation: (locationId) => set({ locationId }),
      setBrand: (brandId, brandName = '', companyName = '', companyId = '') =>
        set({ brandId, brandName, companyName, companyId }),
      setRuntimeSwitching: (isRuntimeSwitching) =>
        set({ isRuntimeSwitching: Boolean(isRuntimeSwitching) }),
      setCustomerLocation: (customerLocation) => set({ customerLocation }),
      setAccountCountry: (accountCountry) => set({ accountCountry }),
      setChannel: (channelId) => set({ channelId }),
      setCurrency: (currencyConfig) => set({ currencyConfig }),
      reset: () => set({ ...empty }),
    }),
    {
      name: STORE_CONTEXT_STORAGE_KEY,
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        accountId: state.accountId,
        channelId: state.channelId,
        locationId: state.locationId,
        brandId: state.brandId,
        brandName: state.brandName,
        companyId: state.companyId,
        companyName: state.companyName,
        accountCountry: state.accountCountry,
        customerLocation: state.customerLocation,
        priceField: state.priceField,
        currencyConfig: state.currencyConfig,
      }),
    },
  ),
);
